export default "__VITE_ASSET__xJdJdzXc__"